export const secondsToMMSS = (seconds: number) => {
  const pad = (num: number): string => String(num).padStart(2, '0');

  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;

  return `${pad(minutes)}:${pad(secs)}`;
};
